import React from 'react';
import { Chip as MuiChip } from '@mui/material';
import { acmeChipSx } from '../../theme/acmeTheme';
import { mergeSx } from './utils/mergeSx';

export default function Chip({ sx, variant = 'outlined', size = 'small', ...props }) {
  return (
    <MuiChip
      variant={variant}
      size={size}
      sx={mergeSx(acmeChipSx, sx)}
      {...props}
    />
  );
}
